import { render, staticRenderFns } from "./AdmissionsView.vue?vue&type=template&id=6f398d21&scoped=true"
import script from "./AdmissionsView.vue?vue&type=script&lang=js"
export * from "./AdmissionsView.vue?vue&type=script&lang=js"
import style0 from "./AdmissionsView.vue?vue&type=style&index=0&id=6f398d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f398d21",
  null
  
)

export default component.exports